module.exports = __webpack_public_path__ + "static/media/background.b9160bbf.jpg";